import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";
import Line from "./Line";

interface IProps {
    title: string;
    headerRight?: React.ReactNode;
    headerSx?: SxProps<Theme>;
    containerSx?: SxProps<Theme>;
    hideDivider?: boolean;
}

export default function DataContainer({
    children,
    title,
    headerRight,
    headerSx,
    containerSx,
    hideDivider,
}: React.PropsWithChildren<IProps>) {
    return (
        <Grid container padding="8px" sx={containerSx}>
            <Grid
                container
                size={12}
                alignItems="center"
                spacing={1}
                sx={headerSx}
            >
                <Grid>
                    <Typography variant="h6">{title}</Typography>
                </Grid>
                {headerRight && (
                    <Grid>
                        {headerRight}
                    </Grid>
                )}
            </Grid>

            {!hideDivider && <Line />}

            {children}
        </Grid>
    );
}
